import { memo } from "react";
import { useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { DialogModal } from "@src/components/DialogModal";
import { isWeb } from "@src/utils/web-helpers";

interface MonitoringRequestSentDialogProps {
  visible: boolean;
  onClose: () => void;
}

export const MonitoringRequestSentDialog = memo(({ visible, onClose }: MonitoringRequestSentDialogProps) => {
  const { theme } = useUnistyles();

  return (
    <DialogModal
      visible={visible}
      onClose={onClose}
      title="Request Sent"
      showCloseButton={false}
      style={{ width: isWeb ? 500 : undefined }}
    >
      <Text textStyle="xs/regular" color="textMuted" mb="5xl">
        Thank you. One of our team members will be in touch shortly to arrange your monitoring service.
      </Text>
      <View
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        gap="sm"
        py="lg"
        rounded={theme.spacing.md}
        style={{ backgroundColor: theme.colors.success[800] }}
      >
        <Icon name="checkmarkOutline" size={20} color={theme.colors.status.success} />
        <Text textStyle="sm/regular" style={{ color: theme.colors.white.default }}>
          Request sent
        </Text>
      </View>
    </DialogModal>
  );
});
